module.exports = __webpack_public_path__ + "static/media/eve-scz.6e921b61.svg";